export const buildLessonUrl = (courseHash: string, lessonId: number) => `/curso/${courseHash}/aula/${lessonId}`